





































import { Component, Provide, Vue, Watch } from 'vue-property-decorator';
import Header from '@/components/common/Header.vue';
import HeaderSmall from '@/components/common/HeaderSmall.vue';
import Footer from '@/components/common/Footer.vue';
import cookie, {
  COOKIE,
  COOKIE_EXPIRATION,
  getRole,
  getSignout,
  getToken,
  getUserStatus,
} from '@/utils/cookie';
import { getQueryParams } from '@/utils/get-query-params';

import { MetaInfo } from 'vue-meta/types/vue-meta';
import { getSubscriptionStatus } from './utils/subscription/subscription.util';
import { UserRole, UserStatus } from './resource/user/user.model';
import ModalStudyGroup from './main-components/common/modal/ModalStudyGroup.vue';

@Component({
  components: {
    Header,
    HeaderSmall,
    Footer,
    ModalStudyGroup,
  },
  metaInfo(this: App): MetaInfo {
    return {
      title: '',
      titleTemplate: '%s Mysoalan',
    };
  },
})
export default class App extends Vue {
  // Provide main colors to all components --------------------

  @Provide('colorBrandDarkPrimary')
  colorBrandDarkPrimary: string = getComputedStyle(
    document.body,
  ).getPropertyValue('--color-brand-dark-primary');

  @Provide('colorBrandDarkSecondary')
  colorBrandDarkSecondary: string = getComputedStyle(
    document.body,
  ).getPropertyValue('--color-brand-dark-secondary');

  @Provide('colorBlackPrimary')
  colorBlackPrimary: string = getComputedStyle(document.body).getPropertyValue(
    '--color-black-primary',
  );

  @Provide('colorWhitePrimary')
  colorWhitePrimary: string = getComputedStyle(document.body).getPropertyValue(
    '--color-white-primary',
  );

  @Provide('colorGrayDarkSecondary')
  colorGrayDarkSecondary: string = getComputedStyle(
    document.body,
  ).getPropertyValue('--color-gray-dark-secondary');

  @Provide('colorGrayLightSecondary')
  colorGrayLightSecondary: string = getComputedStyle(
    document.body,
  ).getPropertyValue('--color-gray-light-secondary');

  // ----------------------------------------------------------

  showMenu = false;
  isLoading = false;
  ModalStudyGroup: any = null;

  get isForceSignout() {
    return getSignout() ? true : false;
  }

  get isLoggedin() {
    return getToken() ? true : false;
  }

  get userStatus(): UserStatus {
    return getUserStatus() || UserStatus.Free;
  }

  get userRole(): UserRole | null {
    const userRole = getRole();

    if (userRole) {
      return userRole;
    } else {
      return null;
    }
  }

  get isPremiumStatus() {
    return this.userStatus === UserStatus.Premium;
  }

  get currentPage() {
    return this.$route.name;
  }

  async created() {
    if (this.isForceSignout) {
      cookie.remove(COOKIE.SIGNOUT, { sameSite: 'Strict' });
      this.$toasted.global.mainToast({
        message: 'Your session has expired. Please signin again',
      });
    } else {
      await this.getUserStatus();
    }

    const source = getQueryParams('sc');

    if (source) {
      this.$sendMpEvent({
        event: this.$mp_value.FirstVisit,
        properties: {
          adSource: source,
        },
      });

      cookie.set(COOKIE.SOURCE, source, {
        sameSite: 'strict',
        expires: COOKIE_EXPIRATION,
      });
    }
  }

  mounted() {
    this.openModalStudyGroup();
  }

  openModalStudyGroup() {
    // const userRole = getRole();
    // const closeStudyGroup = getCloseStudyGroup();
    // if (closeStudyGroup) {
    //   return;
    // }
    // if (
    //   userRole &&
    //   userRole === UserRole.Student
    //   // (userRole === UserRole.Student || userRole === UserRole.parent)
    // ) {
    //   this.ModalStudyGroup && this.ModalStudyGroup();
    //   this.$sendMpEvent({
    //     event: this.$mp_value.LifeTimeView,
    //   });
    //   cookie.set(COOKIE.CLOSE_STUDY_GROUP, 'true', {
    //     sameSite: 'strict',
    //     expires: 1, // NOTE: 1 day expiration
    //   });
    // }
  }

  @Watch('currentPage')
  onCurrentPageChange() {
    this.openModalStudyGroup();
  }

  async getUserStatus() {
    if (!this.isLoggedin) return;

    this.isLoading = true;
    await getSubscriptionStatus();
    this.isLoading = false;
  }

  updateShowMenu(open: boolean) {
    this.showMenu = open;
  }

  onPromoClick() {
    this.ModalStudyGroup && this.ModalStudyGroup();

    this.$sendMpEvent({
      event: this.$mp_value.LifeTimeView,
    });
  }

  ModalStudyGroupAdd(openModal: any) {
    this.ModalStudyGroup = openModal;
  }
}
